export default class URLHelper {
    static slug(name) {
        if ("string" !== typeof name) name = "" + name;

        name = name.toLowerCase();

        //Remove quotes
        name = name.replace(/['"]/g, '');

        //Replace non characters & digits with -
        name = name.replace(/[^0-9a-z]+/g, '-');

        //Remove leading & trailing hyphens
        name = name.replace(/-{2,}/g, '-');
        name = name.replace(/-+$/g, '');
        name = name.replace(/^-+/g, '');

        return name;
    }
}
